import { FC, useMemo } from "react";
import { clsx } from "clsx";
import Image from "next/image";
import { AnimeFadeIn } from "@/pages/AboutPage";

type Props = {
  index: number;
  title: string;
  description: string;
  imgSrc: string;
  imgAlt: string;
};

export const StrongPointItem: FC<Props> = ({
  index,
  title,
  description,
  imgSrc,
  imgAlt,
}): JSX.Element => {
  const indexStr = useMemo(
    () => (index < 10 ? `0${index}` : `${index}`),
    [index],
  );

  return (
    <AnimeFadeIn delay={index * 0.16 + 0.1}>
      <article className="flex flex-col items-start">
        <header className="relative bg-yellow-500 py-8 px-20 font-bold align-baseline leading-none space-x-12">
          <span className={clsx("text-[30px]")}>Point</span>
          <span
            className={clsx("text-white", "text-[60px]", "laptop:text-[70px]")}
          >
            {indexStr}
          </span>
        </header>
        <div className="bg-white w-full shadow-default">
          <div
            className={clsx(
              "flex flex-col items-start gap-20",
              "py-24 px-12",
              "laptop:px-32 laptop:py-48",
            )}
          >
            <h2
              className={clsx(
                "inline-block font-bold border-b-4 border-yellow-500",
                "text-[30px]",
                "laptop:text-[36px]",
              )}
            >
              {title}
            </h2>
            <p
              className={clsx(
                "leading-relaxed",
                "text-[16px]",
                "laptop:text-[18px]",
              )}
            >
              {description}
            </p>
          </div>
          <div className="relative aspect-[8/7]">
            <Image
              className="object-contain object-bottom"
              src={imgSrc}
              alt={imgAlt}
              fill
            />
          </div>
        </div>
      </article>
    </AnimeFadeIn>
  );
};
